import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { GetDate, GetTime } from '../../../app/AppUtils';
import DefaultExcelExport from '../../subcomponents/DefaultExcelExport';
import { postTravelCostExport } from './reportTravelCostsSlice';

export default function ExportExcelTravelCosts({ disabled, jsonData, fileName, report }) {
    const dispatch = useDispatch();

    const { user } = useSelector((state) => state.user);
    const { appLanguage, resourceFinal } = useSelector((state) => state.settings.resource.resources);

    const [excelDataRows, setExcelDataRows] = useState([]);
    const [excelHeaderRow, setExcelHeaderRow] = useState([]);

    const handleExportLog = () => {
        dispatch(postTravelCostExport({
            TravelCostReports: report,
            exportedBy: user.number
        }));
    }

    useEffect(() => {
        if (jsonData) {
            let data = jsonData.map(({ id, ...rest }) => rest);

            // Header row
            setExcelHeaderRow([
                resourceFinal[appLanguage].words.USER_DATA_IBAN,
                resourceFinal[appLanguage].words.NAME_FIRST,
                resourceFinal[appLanguage].words.NAME_INSERTION,
                resourceFinal[appLanguage].words.NAME_LAST,
                `${resourceFinal[appLanguage].words.STUDENT}${resourceFinal[appLanguage].words.NUMBER.toLowerCase()}`,
                resourceFinal[appLanguage].words.USER_DATA_CITY,
                resourceFinal[appLanguage].words.LOCATION_ADDRESS,
                resourceFinal[appLanguage].words.COST,
                resourceFinal[appLanguage].words.DISTANCE,
                resourceFinal[appLanguage].words.TRANSPORT_TYPE,
                resourceFinal[appLanguage].words.APPROVED,
                resourceFinal[appLanguage].words.APPROVED_ON,
                resourceFinal[appLanguage].words.APPROVED_BY,
                resourceFinal[appLanguage].words.ACTIVITY,
                resourceFinal[appLanguage].words.PERFORMANCE,
                resourceFinal[appLanguage].words.REPORT_TRAVEL_COSTS_PERFORMANCE_NUMBER,
            ]);

            // Data rows
            let dataRows = [];

            data?.forEach(item => {
                dataRows.push(
                    Object.keys(item).map(key => {
                        const value = item[key];

                        if (key.toLowerCase().includes("date") || key.toLowerCase().includes("time")) {
                            return value === null ? "" : `${GetDate(value)} (${GetTime(value)})`;
                        }

                        return value === null ? "" : value;
                    })
                );
            });

            setExcelDataRows(dataRows);
        }
    }, [jsonData]);

    return (
        <DefaultExcelExport
            headerRow={excelHeaderRow}
            dataRows={excelDataRows}
            fileName={fileName}
            buttonText={`${resourceFinal[appLanguage].words.EXPORT} ${resourceFinal[appLanguage].words.EXCEL.toLowerCase()}`}
            disabledCondition={disabled}
            callbackFunction={handleExportLog}
        />
    );
}
